import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { FilterCriteria } from '../models/filter.criteria.model';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor(
    private http: HttpClient,
    private _cookieService: CookieService
  ) {}

  searchBackendLocalities(item: any, google = '') {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    return this.http.post<any>(
      `${environment.apiUrl}/api/address/postal/autocomplete${google}`,
      { reference: item },
      optionalParams
    );
  }

  applyFilterSearch(critrerias?: FilterCriteria, includes?: string[]) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    let url = `${environment.apiUrl}/api/list/biens/search/filter`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.post<any>(
      url,
      critrerias,
      optionalParams
    );
  }

  applyFilterSearchLastBiens(critrerias?: FilterCriteria, includes?: string[]) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    let url = `${environment.apiUrl}/api/list/last/biens/exclusif`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.post<any>(
      url,
      critrerias,
      optionalParams
    );
  }

  loadFiltersFormData() {
    return this.http.get<any>(`${environment.apiUrl}/api/biens/filters`);
  }

  fetchTypeBien(dataFilterApi: any) {
    let typeProperties: [] = dataFilterApi.type_property;
    return typeProperties;
  }
  fetchNbPiece(dataFilterApi: any) {
    let nbPieces: [] = dataFilterApi.nb_piece;
    return nbPieces;
  }
  fetchNbRoom(dataFilterApi: any) {
    let nbRooms: [] = dataFilterApi.nb_room;
    return nbRooms;
  }

  fetchSecurity(dataFilterApi: any) {
    let security: [] = dataFilterApi.security;
    return security;
  }
  fetchComodity(dataFilterApi: any) {
    let comodity: [] = dataFilterApi.comfort;
    return comodity;
  }
  fetchProximite(dataFilterApi: any) {
    let proximite: [] = dataFilterApi.proximite;
    return proximite;
  }

  /**
   * getHeaders
   *
   * build our header for more security
   *
   * We send our token via this header
   *
   * @param isPostRequest {boolean}, type of the request
   */
  public getHeaders(isPostRequest: boolean): any {
    let userToken = this._cookieService.get('x-wsse');
    if (userToken === undefined) {
      let json = this._cookieService.get('user_token');
      if (json !== undefined) {
        userToken = JSON.parse(json).user_token;
      }
    }
    if (userToken !== undefined) {
      return new HttpHeaders({
        'x-wsse': userToken,
      });
    } else {
      return {};
    }
  }
}
